// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var EmailNotificationsTemplatesController = function ($scope, EmailNotificationsTemplate, gettextCatalog, gettext) {
    //TODO: we can use group by from here https://github.com/a8m/angular-filter

    function loadTemplates() {
        $scope.templates = EmailNotificationsTemplate.query({}, function (data) {
            var groupArray = [];
            var usedItems = [];
            angular.forEach(data, function (item, idx) {
                if (usedItems.indexOf(item.EventType) === -1) {
                    usedItems.push(item.EventType);
                    groupArray.push({
                        EventType: item.EventType,
                        EventTypeSortOrder: item.EventTypeSortOrder
                    })};
                });
            $scope.eventTypes = groupArray.sort(function(a,b){
                if (a.EventTypeSortOrder < b.EventTypeSortOrder) return -1;
                if (a.EventTypeSortOrder > b.EventTypeSortOrder) return 1;
                return 0;
            });

        });

    };

    $scope.deleteTemplate = function (template) {
        $scope.yesCancel('Delete Email Template', gettextCatalog.getString(gettext('Are you sure?')), function() {
            EmailNotificationsTemplate.remove({ id: template.Id }, function () { loadTemplates(); });
        });
    };

    loadTemplates();
};
EmailNotificationsTemplatesController.$inject = ['$scope', 'EmailNotificationsTemplate', 'gettextCatalog', 'gettext'];
